import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0759acea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "grid-container"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "footer" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "title1" }
const _hoisted_7 = { class: "meta" }
const _hoisted_8 = { class: "date" }
const _hoisted_9 = { class: "main-container" }
const _hoisted_10 = { class: "content-container" }
const _hoisted_11 = { "aria-label": "Breadcrumb" }
const _hoisted_12 = { class: "breadcrumb" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, "Home")
], -1))
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "img-wrapper" }
const _hoisted_16 = ["src", "onClick", "alt"]
const _hoisted_17 = { class: "text-content" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "heading" }
const _hoisted_20 = { class: "info" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("by ")
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "date" }
const _hoisted_24 = { class: "mt-2 truncate-text" }
const _hoisted_25 = {
  key: 0,
  class: "pagination"
}
const _hoisted_26 = { class: "sidebar-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_LeftSideBar = _resolveComponent("LeftSideBar")!
  const _component_front_sidebar = _resolveComponent("front-sidebar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.getCategoryWisePosts().length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCategoryWisePosts(), (post, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: post.id || index,
              class: _normalizeClass(['grid-item', _ctx.dynamicClass(index)]),
              onClick: ($event: any) => (_ctx.viewPostById(post))
            }, [
              _createElementVNode("img", {
                src: _ctx.extractImgUrl(post),
                alt: post?.indlaeg_slug
              }, null, 8, _hoisted_3),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: "category-badge",
                  onClick: (event) => _ctx.goToCategories(post?.indlaeg_kategori_id?.indlaeg_kategori_titel, event)
                }, _toDisplayString(post?.indlaeg_kategori_id?.indlaeg_kategori_titel || "No Category"), 9, _hoisted_5),
                _createElementVNode("div", _hoisted_6, _toDisplayString(post?.indlaeg_versionerings_id?.[0]?.indlaeg_versionering_titel || "No Title"), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_component_va_icon, {
                      size: "15px",
                      name: "schedule"
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(post?.updatedAt)), 1),
                    _createVNode(_component_va_icon, {
                      size: "15px",
                      name: "visibility"
                    }),
                    _createElementVNode("span", null, _toDisplayString(post?.indlaeg_visninger || 0), 1)
                  ])
                ])
              ])
            ], 10, _hoisted_2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_LeftSideBar),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("nav", _hoisted_11, [
          _createElementVNode("ul", _hoisted_12, [
            _hoisted_13,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBreadcrumbs(), (bread, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createVNode(_component_va_icon, { name: "chevron_right" }),
                _createElementVNode("a", {
                  href: bread.path
                }, _toDisplayString(bread.name), 9, _hoisted_14)
              ]))
            }), 128))
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showPostPageWise(), (post, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "post-list",
            key: post.id || index
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("img", {
                src: _ctx.extractImgUrl(post),
                onClick: ($event: any) => (_ctx.viewPostById(post)),
                alt: post?.indlaeg_slug
              }, null, 8, _hoisted_16)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                class: "category-badge",
                onClick: (event) => _ctx.goToCategories(post?.indlaeg_kategori_id?.indlaeg_kategori_titel, event)
              }, _toDisplayString(post.indlaeg_kategori_id?.indlaeg_kategori_titel), 9, _hoisted_18),
              _createElementVNode("p", _hoisted_19, _toDisplayString(post.indlaeg_versionerings_id?.[0]?.indlaeg_versionering_titel), 1),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", null, [
                  _hoisted_21,
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_ctx.goToAuthorPosts(post.indlaeg_forfatter?.firstname + '-' + post.indlaeg_forfatter?.lastname)),
                    class: "red-hover"
                  }, _toDisplayString(post.indlaeg_forfatter?.firstname + ' ' + post.indlaeg_forfatter?.lastname), 9, _hoisted_22)
                ]),
                _createElementVNode("span", _hoisted_23, [
                  _createVNode(_component_va_icon, {
                    size: "11px",
                    name: "schedule"
                  }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(post?.updatedAt)), 1),
                  _createVNode(_component_va_icon, {
                    size: "11px",
                    name: "visibility"
                  }),
                  _createElementVNode("span", null, _toDisplayString(post?.indlaeg_visninger || 0), 1)
                ])
              ]),
              _createElementVNode("p", _hoisted_24, _toDisplayString(post?.indlaeg_slug), 1)
            ])
          ]))
        }), 128)),
        (_ctx.getPosts().length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("span", {
                class: "box",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentPage(_ctx.getCurrentPage() - 1)))
              }, [
                _createVNode(_component_va_icon, { name: "chevron_left" })
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationView(), (pageNo, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: index,
                  class: _normalizeClass(["box", { active: pageNo === _ctx.getCurrentPage() }]),
                  onClick: _cache[1] || (_cache[1] = (event)=> _ctx.setCurrentPage(event.target.innerText))
                }, _toDisplayString(pageNo), 3))
              }), 128)),
              _createElementVNode("span", {
                class: "box",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCurrentPage(_ctx.getCurrentPage() + 1)))
              }, [
                _createVNode(_component_va_icon, { name: "chevron_right" })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_front_sidebar)
      ])
    ])
  ], 64))
}